import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListagemComposicao from "components/Relatorio/RelatorioComposicaoContas/ListagemComposicao";
import { OperacaoEnum } from "resources/enums/conta";

function RelatorioDespesasPorCategoriaPage() {
  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Relatório de despesas com composição",
      url: "/relatorios/financeiro/composicao-despesas",
    },
  ]);

  return (
    <Container>
      <ListagemComposicao operacao={OperacaoEnum.Despesa} />
    </Container>
  );
}

export default RelatorioDespesasPorCategoriaPage;
